import axios from "axios";

export const GetOpComparisonList = async (params) => {
    let data =  {
        StartDate : params.startDate,
        EndDate : params.endDate,
        Operator : params.operator,
        ProductType : params.productType,
        CompanyId: params.companyId,
        UserId: params.userId,
        RoleId: params.roleId,
    }

    let response;

    try{
        response = await axios.post(`/api/OpComparison/GetOpComparisonList`, data);
        if(response && response.status === 200){
            return response.data.records;
        }else{
            return response.status;
        }
    }catch(error){
        if(error.response.status === 401){
            return error.response.status;
        }
    }
}